import { render, staticRenderFns } from "./Practice.vue?vue&type=template&id=96e34e7e&scoped=true&lang=html&"
import script from "./Practice.vue?vue&type=script&lang=js&"
export * from "./Practice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e34e7e",
  null
  
)

export default component.exports